import get from 'hs-lodash/get';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
const getApplicationName = state => get(state, 'automationTab.parentApplication.applicationName', APPLICATION_NAMES.FORMSUI);
export default getApplicationName;